module.exports = __webpack_public_path__ + "img/Illustration-12.d83c6480.png";